import {
    Avatar,
    Box,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    Stack,
    Typography
} from "@mui/material";
import {FC, useState} from "react";
import React from "react";
import {RecordPageBO, RecordPageVO, useQueryRecordPage} from "@/service/record.s";
import {styled} from "@mui/material/styles";
import {drawerClasses} from "@mui/material/Drawer";
import InfiniteScroll from "react-infinite-scroll-component";
import {PaginationVO} from "@/model/global";
import {formatTime, mergeData, useAsyncEffect} from "@/helper/method";
import IconButton from "@mui/material/IconButton";
import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Chip from "@mui/material/Chip";
import {useGlobalActions} from "@/store/global.c";
import {RecordForm} from "@/widget/RecordForm/RecordForm";

export interface SalesRecordProps {
    customerId?: number
}

const ScrollRecordWrapper = styled(Box)(() => ({
    height: 400,
    minHeight: 80,
    display: "flex",
    flexDirection: "column",
    overflowY: "scroll",
    "::-webkit-scrollbar": {
        width: 0,
        height: 0,
    },
    "::-webkit-scrollbar-thumb": {
        [`& .${drawerClasses.paper}`]: {
            backgroundColor: "background.paper",
        },
        cursor: "pointer",
        borderRadius: "3px",
    },
    "&:hover::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(231,231,226)",
    },
}));

export const SalesRecord: FC<SalesRecordProps> = ({customerId}) => {
    const {mutateAsync: recordPageMutate} = useQueryRecordPage()
    const {setDialogModal} = useGlobalActions()
    const [record, setRecord] = useState<PaginationVO<RecordPageVO>>()

    useAsyncEffect(async () => {
        if (customerId) {
            await loadData({targetId: customerId, current: 1})
        }
    }, [customerId])

    const loadData = async (params: Omit<RecordPageBO, "size">) => {
        const result = await recordPageMutate({...params, size: 5})
        if (result.code == 0) {
            setRecord(mergeData<RecordPageVO>(
                record?.list || [],
                result.data,
            ))
        }
    }

    return <Stack gap={1}>
        <Card variant='highlighted' onClick={() => {
            setDialogModal({
                open: true,
                header: "发布跟进记录",
                onSearch: () => loadData({current: 1, targetId: customerId}),
                write: 'add',
                body: <RecordForm mode={'dialog'} targetId={customerId}/>,
                maxWidth: 'xs'
            })
        }} sx={{p: 0, border: 'none', bgcolor: '#f2f2f2', borderRadius: '2px'}}>
            <CardActionArea>
                <Stack direction='row' py={0.4} justifyContent={'space-between'} alignContent='center' alignItems='center'>
                    <Stack direction='row' alignContent='center' alignItems='center'>
                        <IconButton>
                            <SaveAsOutlinedIcon color={'disabled'}/>
                        </IconButton>
                        <Typography variant={'subtitle2'} color={'#333'}>点击发布跟进记录</Typography>
                    </Stack>
                    <Typography pr={1} color={'textSecondary'}>共 {record?.total ?? 0} 条</Typography>
                </Stack>
            </CardActionArea>
        </Card>
        <ScrollRecordWrapper id={'record'}>
            <InfiniteScroll dataLength={record?.list?.length || 0} next={async () => {
                await loadData({current: record!.current + 1, targetId: customerId})
            }} hasMore={record?.hasMore || false} scrollableTarget={`record`} loader={<Box display={'flex'} justifyContent={'center'}>加载中</Box>}>
                <Box gap={1.5} display={'flex'} flexDirection={'column'}>
                    {record?.list?.map((item: RecordPageVO, index: number) => (
                        <Card key={index} sx={{borderColor: '#f5f5f4', bgcolor: '#f2f2f2', p: 1}} variant='highlighted'>
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: 'orange', width: 28, height: 28}} src={item.avatar}>
                                        {item.creator}
                                    </Avatar>
                                }
                                action={
                                    <Box pr={0.5}>
                                        <IconButton size={'small'} aria-label="settings">
                                            <EditOutlinedIcon onClick={() => {
                                                setDialogModal({
                                                    open: true,
                                                    header: "修改跟进记录",
                                                    onSearch: () => loadData({current: 1, targetId: customerId}),
                                                    write: 'edit',
                                                    id: item.id,
                                                    body: <RecordForm mode={'dialog'} targetId={customerId}/>,
                                                    maxWidth: 'xs'
                                                })
                                            }} fontSize={'small'} color={'disabled'}/>
                                        </IconButton>
                                    </Box>
                                }
                                title={<Stack alignItems={'center'} alignContent={'center'} direction={'row'} spacing={2}> <Typography> {item.creator} </Typography>
                                    <Typography> {formatTime("m", item.createdAt)} </Typography> </Stack>}
                            />
                            <CardContent>
                                <Typography my={1} variant="body1" component="div">
                                    {item.content}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Stack direction='row' spacing={4}>
                                    <Stack direction='row' spacing={0.7} alignContent={'end'} alignItems={'end'}>
                                        <Typography variant="body1" component="div">
                                            跟进方式
                                        </Typography>
                                        <Chip size="small" sx={{border: ' none'}} color={'secondary'} variant={'outlined'} label={item.way}/>
                                    </Stack>
                                    <Stack direction='row' spacing={0.7} alignContent={'end'} alignItems={'end'}>
                                        <Typography variant="body1" component="div">
                                            跟进内容
                                        </Typography> <Chip size="small" sx={{border: ' none', fontWeight: 400}} color={'success'} label={item.type}/>
                                    </Stack>
                                </Stack>
                            </CardActions>
                        </Card>
                    ))
                    }
                </Box>
            </InfiniteScroll>
        </ScrollRecordWrapper>
        {/*<Box >*/}
        {/*    */}

        {/*    <Card sx={{borderColor: '#f5f5f4', bgcolor: '#f2f2f2', p: 1}} variant='highlighted'>*/}
        {/*        <CardHeader*/}
        {/*            avatar={*/}
        {/*                <Avatar sx={{bgcolor: 'orange', width: 32, height: 32}} aria-label="recipe">*/}
        {/*                    R*/}
        {/*                </Avatar>*/}
        {/*            }*/}
        {/*            action={*/}
        {/*                <Box pr={0.5}>*/}
        {/*                    <IconButton size={'small'} aria-label="settings">*/}
        {/*                        <EditOutlinedIcon fontSize={'small'} color={'disabled'}/>*/}
        {/*                    </IconButton>*/}
        {/*                </Box>*/}
        {/*            }*/}
        {/*            title="超级管理员"*/}
        {/*        />*/}
        {/*        <CardContent>*/}
        {/*            <Typography my={2} variant="body1" component="div">*/}
        {/*                be{}nev{}o{}lent*/}
        {/*            </Typography>*/}
        {/*        </CardContent>*/}
        {/*        <CardActions>*/}
        {/*            <Stack direction='row' spacing={4}>*/}
        {/*                <Stack direction='row' spacing={0.5} alignContent={'end'} alignItems={'end'}>*/}
        {/*                    <Typography variant="body1" color={'textSecondary'} component="div">*/}
        {/*                        跟进方式*/}
        {/*                    </Typography> <Chip size="small" sx={{border: ' none'}} color={'success'} variant={'outlined'} label={'电话沟通'}/>*/}
        {/*                </Stack>*/}
        {/*                <Stack direction='row' spacing={0.5} alignContent={'end'} alignItems={'end'}>*/}
        {/*                    <Typography variant="body1" color={'textSecondary'} component="div">*/}
        {/*                        跟进时间*/}
        {/*                    </Typography> <Chip size="small" sx={{border: ' none', fontWeight: 400}} color={'default'} label={'2024-12-20 12:50'}/>*/}
        {/*                </Stack>*/}
        {/*            </Stack>*/}
        {/*        </CardActions>*/}
        {/*    </Card>*/}
        {/*</Box>*/}
        {/*<ListItem disablePadding={true} alignItems="flex-start">*/}
        {/*    <ListItemAvatar sx={{minWidth: 40}}>*/}
        {/*        <Avatar sx={{height: 32, width: 32}} alt="Remy Sharp" src="/static/images/avatar/1.jpg"/>*/}
        {/*    </ListItemAvatar>*/}
        {/*    <ListItemText*/}
        {/*        primary={<Stack alignContent={'center'} alignItems={'center'} direction={'row'} justifyContent={'space-between'}><Typography*/}
        {/*        >李蓓</Typography>*/}
        {/*            <Typography variant={'subtitle2'} color={'textSecondary'} fontSize={14}>2025-03-12</Typography></Stack>}*/}
        {/*        secondary={*/}
        {/*            <React.Fragment>*/}
        {/*                创建联系人徐霞客*/}
        {/*            </React.Fragment>*/}
        {/*        }*/}
        {/*    />*/}
        {/*</ListItem>*/}
        {/*</List>*/}
        {/*</Box>*/}
    </Stack>
}